module.exports = __webpack_public_path__ + "img/step_3.13d4a578.png";